import { Typography } from "@mui/material"
import { useNavigate } from "react-router-dom"
import { useDispatch } from "react-redux"
import {
  Amount,
  CenterContainer,
  ContentContainer,
  RecipientContainer,
  SourceDescription,
  TopContainer,
  IconContainer,
  ButtonsContainer,
  StyledButton,
} from "./styled"
import IconBox from "../../../components/IconBox"
import BankIcon from "../../../components/BankIcon"
import { formatAmount, formatPhoneNumber } from "../../../utils/formatters"
import SBPIconNoExt from "../../../components/SBPIconNoExt"
import { RUBLE } from "../../../utils/constants"
import { SbpOutcomeTransferRequestStatusProps } from "./props"
import { useGetSbpOutcomeTransferRequestStatus } from "../../../api/hooks/useGetSbpOutcomeTtransferRequestStatus"
import { getStatusDetails } from "../../../utils/transferRequest"
import UIIcon from "../../../components/UIIcon"
import { sendCustomEvent } from "../../../events/events"
import { resetSlice } from "../../../store/slices/m2mSlice"
import { resetSteps, setNextStep } from "../../../store/slices/routingSlice/routingSlice"
import { STEPS_NAME } from "../../../store/slices/routingSlice/flowsSteps"


const SbpOutcomeTransferRequestStatus = ({
  outcomeTransferRequestId,
  enablePolling = false,
}: SbpOutcomeTransferRequestStatusProps) => {
  const navigate = useNavigate()
  const dispatch = useDispatch()

  const handleQuitEvent = () => {
    sendCustomEvent({
      eventName: "quit",
    })
  }

  const handleDoneButtonClick = () => {
    handleQuitEvent()
    dispatch(resetSlice())
    dispatch(resetSteps())
    navigate("/quit")
  }

  const handleAgainButtonClick = () => {
    dispatch(setNextStep(STEPS_NAME.m2mPull.refill))
  }

  const { data: transferRequest } = useGetSbpOutcomeTransferRequestStatus(
    outcomeTransferRequestId,
    enablePolling,
  )

  if (!transferRequest) {
    return null
  }

  const statusDetails = getStatusDetails(transferRequest!.status)

  return (
    <ContentContainer>
      <TopContainer>
        <IconBox size="lg" color="yellow">
          <UIIcon
            iconName={statusDetails.icon}
            size={80}
          />
        </IconBox>
        <SourceDescription>
          {statusDetails.message}
        </SourceDescription>    
        <Amount>
          {formatAmount(transferRequest.amount)} {RUBLE}
        </Amount>
      </TopContainer>
      <CenterContainer>
        <IconBox>
          <BankIcon logoUrl={transferRequest.bankInfo!.logoUrl} size={46} />
        </IconBox>
        <RecipientContainer> 
          <Typography variant="h4">{transferRequest.bankInfo!.title}</Typography>
          <Typography variant="h6">{formatPhoneNumber(transferRequest.customerInfo.phoneNumber)}</Typography>
        </RecipientContainer>
      </CenterContainer>
      <IconContainer>
        <SBPIconNoExt size={60} />
      </IconContainer>
      <ButtonsContainer>
        {!statusDetails.isFinal && (
          <StyledButton
            variant="contained"
            color="secondary"
            onClick={handleDoneButtonClick}
          >
            Закрыть
          </StyledButton>
        )}
        {statusDetails.isFinal && (
          <>
            {statusDetails.isSuccesseful && (
              <StyledButton variant="contained" onClick={handleDoneButtonClick}>
                Готово
              </StyledButton>
            )}
            {!statusDetails.isSuccesseful && (
              <>
                <StyledButton
                  variant="contained"
                  color="secondary"
                  onClick={handleDoneButtonClick}
                >
                  Закрыть
                </StyledButton>
                <StyledButton variant="contained" onClick={handleAgainButtonClick}>
                  Попробовать еще раз
                </StyledButton>
              </>
            )}
          </>
        )}
        
      </ButtonsContainer>  
    </ContentContainer>
  )
}

export default SbpOutcomeTransferRequestStatus
